// 中文界面文案；工具说明在 src/content/ 维护。
export default {
  "site": {
    "title": "月升工具网 - 超实用在线查询工具",
    "name": "月升工具网",
    "slogan": "超实用在线查询工具，让工作生活更高效"
  },
  "nav": {
    "home": "首页",
    "json": "JSON格式化",
    "timestamp": "时间戳转换",
    "wordcount": "字数统计",
    "calculator": "计算器",
    "about": "关于我们",
    "privacy": "隐私政策",
    "blog": "实操指南"
  },
  "theme": {
    "light": "切换到明亮模式",
    "dark": "切换到暗黑模式"
  },
  "common": {
    "copy": "复制",
    "copyResult": "复制结果",
    "clear": "清空",
    "calculate": "计算",
    "convert": "转换",
    "copied": "已复制到剪贴板！",
    "copyFailed": "复制失败，请手动复制",
    "inputPlaceholder": "请输入...",
    "resultPlaceholder": "结果将显示在这里...",
    "error": "错误",
    "success": "成功",
    "loading": "加载中...",
    "refresh": "刷新"
  },
  "json": {
    "title": "JSON格式化工具",
    "subtitle": "在线验证、格式化和压缩 JSON 数据，支持语法高亮显示，是程序员开发调试的必备工具",
    "format": "格式化",
    "compress": "压缩",
    "inputLabel": "输入 JSON",
    "outputLabel": "输出结果",
    "inputPlaceholder": "请输入或粘贴JSON数据...",
    "outputPlaceholder": "格式化后的结果将显示在这里...",
    "indentSpaces": "缩进空格数",
    "formatSuccess": "JSON格式化成功！",
    "compressSuccess": "JSON压缩成功！",
    "emptyError": "请输入JSON数据",
    "formatError": "JSON格式错误",
    "whatIsJson": "什么是 JSON？",
    "whatIsJsonDesc": "JSON（JavaScript Object Notation，JavaScript 对象表示法）是一种轻量级的数据交换格式，由道格拉斯·克罗克福特（Douglas Crockford）在 2001 年首次提出。JSON 基于 JavaScript 语言的一个子集，但它是独立于语言的文本格式，几乎所有现代编程语言都支持 JSON 的解析和生成。JSON 已经成为互联网上最常用的数据格式之一，在 Web API、配置文件、数据存储、前后端通信等场景中广泛应用。",
    "features": "JSON 格式化工具的功能",
    "featureFormat": "格式化（美化）：将压缩的 JSON 数据转换为带缩进的、易于阅读的格式，方便查看数据结构和调试程序。",
    "featureCompress": "压缩（最小化）：移除 JSON 中的空格和换行符，减小数据体积，适合网络传输和存储。",
    "featureValidate": "语法验证：自动检测 JSON 格式是否正确，帮助您快速发现语法错误。",
    "featureCopy": "一键复制：处理完成后可以一键复制结果，方便在其他地方使用。",
    "howToUse": "如何使用本工具",
    "howToUseSteps": [
      "在左侧文本框中粘贴或输入您的 JSON 数据。",
      "点击\"格式化\"按钮美化 JSON，或点击\"压缩\"按钮最小化 JSON。",
      "如果 JSON 格式有误，工具会显示具体的错误信息。",
      "处理成功后，结果会显示在右侧文本框中，点击\"复制结果\"即可复制。"
    ],
    "example": "JSON 格式示例",
    "exampleDesc": "一个标准的 JSON 对象示例：",
    "commonErrors": "常见 JSON 错误",
    "errorQuotes": "缺少引号：JSON 的键名必须用双引号包围，单引号或不加引号都是错误的。",
    "errorTrailingComma": "末尾多余逗号：数组或对象的最后一个元素后面不能有逗号。",
    "errorSingleQuote": "使用单引号：JSON 只支持双引号，不支持单引号。",
    "errorComments": "注释：标准 JSON 不支持注释，添加注释会导致解析失败。",
    "jsonHistory": "JSON 的发展历史",
    "jsonHistoryDesc": "JSON 格式诞生于 2001 年，最初是作为 XML 的轻量级替代方案而设计的。2006 年，JSON 被正式定义为 RFC 4627 标准。2013 年，ECMA-404 标准发布，进一步规范了 JSON 的语法。如今，JSON 已经完全取代 XML 成为 Web 开发中最主流的数据交换格式。",
    "jsonVsXml": "JSON 与 XML 的对比",
    "jsonVsXmlItems": [
      "体积更小：相同数据下，JSON 格式通常比 XML 小 30%-50%，节省网络带宽。",
      "解析更快：JSON 可以直接被 JavaScript 解析，无需额外的解析器，处理速度更快。",
      "更易读写：JSON 语法简洁直观，人类可以轻松阅读和手写 JSON 数据。",
      "原生支持：现代浏览器和编程语言都内置了 JSON 解析功能，无需额外依赖。"
    ],
    "jsonDataTypes": "JSON 支持的数据类型",
    "jsonDataTypesItems": [
      "字符串（String）：用双引号包围的文本，如 \"hello world\"",
      "数字（Number）：整数或浮点数，如 42、3.14、-100",
      "布尔值（Boolean）：true 或 false",
      "空值（Null）：null 表示空或无值",
      "数组（Array）：用方括号包围的有序值列表，如 [1, 2, 3]",
      "对象（Object）：用花括号包围的键值对集合，如 {\"name\": \"张三\"}"
    ],
    "jsonUseCases": "JSON 的常见应用场景",
    "jsonUseCasesItems": [
      "Web API 数据传输：RESTful API 几乎都使用 JSON 作为数据格式",
      "配置文件：package.json、tsconfig.json 等项目配置文件",
      "数据存储：MongoDB 等 NoSQL 数据库使用 JSON 格式存储数据",
      "前后端通信：Ajax 请求通常使用 JSON 传递数据",
      "日志记录：结构化日志常采用 JSON 格式便于分析",
      "消息队列：Kafka、RabbitMQ 等消息中间件常用 JSON 格式传递消息"
    ],
    "jsonBestPractices": "JSON 使用最佳实践",
    "jsonBestPracticesItems": [
      "使用有意义的键名：键名应该清晰表达数据含义，如用 \"userName\" 而非 \"u\"",
      "保持数据结构一致：同类型数据应保持相同的结构，便于解析处理",
      "避免深层嵌套：过深的嵌套会增加解析复杂度，建议不超过 4-5 层",
      "使用数组存储列表：同类型的多个元素应使用数组而非编号键",
      "日期使用 ISO 8601 格式：如 \"2024-01-15T10:30:00Z\"，便于跨平台解析"
    ]
  },
  "timestamp": {
    "title": "时间戳转换工具",
    "subtitle": "Unix 时间戳与标准日期时间格式的在线互相转换，支持秒级和毫秒级时间戳",
    "currentTimestamp": "当前时间戳",
    "toDate": "时间戳 → 日期时间",
    "toTimestamp": "日期时间 → 时间戳",
    "inputPlaceholder": "输入时间戳（秒或毫秒）",
    "seconds": "秒 (s)",
    "milliseconds": "毫秒 (ms)",
    "localTime": "本地时间",
    "utcTime": "UTC时间",
    "isoFormat": "ISO格式",
    "secondsTimestamp": "秒级时间戳",
    "millisecondsTimestamp": "毫秒级时间戳",
    "currentTime": "当前时间",
    "invalidNumber": "请输入有效的数字",
    "invalidTimestamp": "无效的时间戳",
    "conversionFailed": "转换失败",
    "whatIsTimestamp": "什么是 Unix 时间戳？",
    "whatIsTimestampDesc": "Unix 时间戳（Unix Timestamp），也叫 POSIX 时间或 Epoch 时间，是一种时间表示方式。它定义为从 1970 年 1 月 1 日 00:00:00 UTC（协调世界时）到现在所经过的总秒数，不考虑闰秒。这个起始时间点被称为「Unix 纪元」（Unix Epoch）。由于时间戳是一个简单的整数，不依赖于时区，因此在不同系统、不同地区之间传递时间信息时非常方便和可靠。",
    "useCases": "时间戳的应用场景",
    "useCaseDb": "数据库存储：很多数据库使用时间戳来存储时间信息，因为整数比日期字符串更节省空间，查询效率也更高。",
    "useCaseApi": "API 接口：Web API 通常使用时间戳来传递时间参数，避免时区转换带来的问题。",
    "useCaseLog": "日志记录：系统日志常用时间戳记录事件发生的精确时间。",
    "useCaseCache": "缓存控制：浏览器和服务器使用时间戳来判断缓存是否过期。",
    "comparison": "秒级时间戳 vs 毫秒级时间戳",
    "comparisonDesc": "时间戳有两种常见的精度：",
    "comparisonSeconds": "秒级时间戳（10 位）：例如 1707235200，精确到秒，常用于 Unix/Linux 系统和大多数后端编程语言。",
    "comparisonMilliseconds": "毫秒级时间戳（13 位）：例如 1707235200000，精确到毫秒，常用于 JavaScript 和需要更高精度的场景。",
    "programmingExamples": "常见编程语言获取时间戳",
    "timestampHistory": "时间戳的由来",
    "timestampHistoryDesc": "1970 年 1 月 1 日被选为 Unix 纪元的起点，主要是因为 Unix 操作系统最初是在 1969-1970 年间由贝尔实验室的肯·汤普森（Ken Thompson）和丹尼斯·里奇（Dennis Ritchie）开发的。当时选择一个「最近的」、「容易记忆的」时间点作为起点。这个设计决定一直沿用至今，成为计算机领域的标准。",
    "y2038Problem": "2038 年问题",
    "y2038ProblemDesc": "32 位系统存储的时间戳最大值为 2147483647（2^31-1），对应的时间是 2038 年 1 月 19 日 03:14:07 UTC。届时 32 位系统的时间戳将溢出，类似于「千年虫」问题。好消息是，大多数现代系统已经使用 64 位整数存储时间戳，可以表示到约 2920 亿年后的时间。",
    "timezoneExplain": "时区与时间戳",
    "timezoneExplainDesc": "时间戳的一大优势是它与时区无关。无论你在北京、纽约还是伦敦，同一时刻的时间戳都是相同的。在显示时间时，应用程序会根据用户所在时区将时间戳转换为本地时间。这就是为什么在跨时区协作时，使用时间戳可以避免很多困惑。",
    "commonTimestamps": "常见特殊时间戳",
    "commonTimestampsItems": [
      "0：1970-01-01 00:00:00 UTC（Unix 纪元）",
      "1000000000：2001-09-09 01:46:40 UTC（10 亿秒）",
      "1234567890：2009-02-13 23:31:30 UTC（著名的「1234567890」时刻）",
      "2147483647：2038-01-19 03:14:07 UTC（32 位系统最大值）"
    ],
    "timestampTips": "使用时间戳的技巧",
    "timestampTipsItems": [
      "存储时使用 UTC 时间戳，显示时转换为本地时间",
      "对于需要高精度的场景（如金融交易），使用毫秒级甚至微秒级时间戳",
      "在数据库中为时间戳字段建立索引，可大幅提升时间范围查询的性能",
      "注意前后端时间戳精度的统一，JavaScript 使用毫秒，部分后端语言使用秒"
    ]
  },
  "wordcount": {
    "title": "字数统计",
    "subtitle": "统计文本的字符数、字数、行数等详细信息",
    "totalChars": "总字符数",
    "charsNoSpace": "字符(不含空格)",
    "chineseChars": "中文字符",
    "englishChars": "英文字母",
    "englishWords": "英文单词",
    "numbers": "数字",
    "lines": "行数",
    "paragraphs": "段落数",
    "inputLabel": "输入文本",
    "inputPlaceholder": "在此输入或粘贴文本，实时统计字数...",
    "tip": "提示：支持中英文混合统计，中文按字符计算，英文按单词计算",
    "whyWordCount": "为什么需要字数统计？",
    "whyWordCountDesc": "字数统计是写作和内容创作中非常重要的功能。无论是学生写论文、作家写小说、编辑审稿、还是新媒体运营写推文，都需要关注字数。不同场景对字数有不同的要求，精确的字数统计可以帮助你更好地控制内容长度。",
    "wordCountUseCases": "字数统计的应用场景",
    "wordCountUseCasesItems": [
      "学术论文：毕业论文、期刊论文通常有严格的字数要求",
      "新媒体运营：微信公众号、微博等平台对标题和正文有字数限制",
      "翻译工作：翻译计费通常按字数或单词数计算",
      "SEO优化：搜索引擎对文章长度有一定偏好，太短或太长都不利于排名",
      "出版编辑：书籍编辑需要控制章节和全书字数"
    ],
    "countingRules": "中英文字数统计规则",
    "countingRulesDesc": "中文和英文的统计规则有所不同：",
    "countingRulesItems": [
      "中文：通常按字符计算，一个汉字算一个字",
      "英文：通常按单词计算，以空格分隔",
      "混合文本：中文按字符、英文按单词分别统计",
      "标点符号：根据需求可计入或不计入字数"
    ],
    "writingTips": "写作字数建议",
    "writingTipsItems": [
      "微信公众号文章：建议 1500-3000 字，便于读者阅读",
      "知乎回答：优质回答通常在 500-2000 字",
      "博客文章：SEO 友好的文章建议 1000-2500 字",
      "新闻稿：通常 300-800 字，简洁明了",
      "产品说明：根据复杂度，500-1500 字为宜"
    ],
    "platformLimits": "各平台字数限制速查",
    "platformLimitsItems": [
      "微信公众号：标题最多 64 字，正文无上限但建议不超过 5000 字",
      "微博：正文最多 2000 字，转发评论最多 140 字",
      "小红书笔记：标题最多 20 字，正文最多 1000 字",
      "抖音标题：最多 55 字，建议控制在 30 字以内",
      "知乎回答：无字数限制，但超过 300 字的回答更容易获得推荐",
      "豆瓣短评：最多 350 字；影评无字数限制"
    ],
    "readingTime": "阅读时间估算",
    "readingTimeDesc": "了解阅读时间可以帮助你更好地规划文章长度。研究表明，中文阅读速度约为每分钟 300-500 字，英文阅读速度约为每分钟 200-300 词。也就是说，一篇 1500 字的中文文章大约需要 3-5 分钟阅读。互联网用户的平均注意力持续时间约为 8 秒，因此文章的开头部分尤为重要，需要在前 100 字内吸引读者继续阅读。",
    "seoWordCount": "字数与 SEO 的关系",
    "seoWordCountDesc": "搜索引擎优化（SEO）与文章字数有密切关系。研究数据显示，排名靠前的网页平均内容长度在 1500-2500 字之间。但字数并非越多越好，关键是内容的质量和相关性。Google 等搜索引擎更看重内容是否全面回答了用户的搜索问题，而不是简单地堆砌字数。高质量的 1000 字文章往往比低质量的 3000 字文章排名更好。",
    "writingEfficiency": "提高写作效率的方法",
    "writingEfficiencyItems": [
      "先列提纲：在写作前列出文章大纲，明确每个部分的要点和预计字数",
      "番茄工作法：每 25 分钟专注写作，休息 5 分钟，保持高效产出",
      "分段写作：将长文章拆分为多个独立段落，逐个完成",
      "先写后改：初稿阶段不要纠结用词，完成全文后再统一修改润色",
      "利用工具：使用字数统计工具实时监控进度，确保达到目标字数"
    ]
  },
  "markdown": {
    "title": "Markdown编辑器",
    "subtitle": "实时预览的Markdown编辑器，支持常用语法",
    "bold": "粗体",
    "italic": "斜体",
    "heading": "标题",
    "list": "无序列表",
    "orderedList": "有序列表",
    "link": "链接",
    "image": "图片",
    "inlineCode": "行内代码",
    "codeBlock": "代码块",
    "quote": "引用",
    "divider": "分割线",
    "copyMarkdown": "复制Markdown",
    "copyHtml": "复制HTML",
    "inputLabel": "Markdown 输入",
    "previewLabel": "预览",
    "inputPlaceholder": "在此输入Markdown内容...",
    "syntaxHelp": "Markdown 语法参考",
    "markdownCopied": "Markdown已复制！",
    "htmlCopied": "HTML已复制！",
    "whatIsMarkdown": "什么是 Markdown？",
    "whatIsMarkdownDesc": "Markdown 是由约翰·格鲁伯（John Gruber）在 2004 年创建的一种轻量级标记语言。它的设计理念是让人们使用简单、易读的纯文本格式编写文档，然后可以转换成结构化的 HTML。Markdown 语法简洁直观，学习成本低，已成为程序员、技术写作者和内容创作者的首选写作格式。",
    "markdownAdvantages": "Markdown 的优势",
    "markdownAdvantagesItems": [
      "语法简单：几分钟即可学会基本语法，上手极快",
      "专注内容：不需要关心排版格式，专心写作",
      "跨平台：纯文本格式，任何编辑器都能打开",
      "版本控制友好：适合用 Git 管理，方便协作和追踪修改",
      "广泛支持：GitHub、GitLab、Notion、语雀等平台都支持"
    ],
    "markdownSyntaxGuide": "常用语法一览",
    "markdownSyntaxGuideItems": [
      "# 一级标题、## 二级标题、### 三级标题",
      "**粗体** 或 __粗体__",
      "*斜体* 或 _斜体_",
      "[链接文字](URL)",
      "![图片描述](图片URL)",
      "- 无序列表 或 * 无序列表",
      "1. 有序列表",
      "> 引用文字",
      "`行内代码`",
      "```代码块```",
      "--- 或 *** 分割线"
    ],
    "markdownUseCases": "Markdown 应用场景",
    "markdownUseCasesItems": [
      "技术文档：README、API 文档、开发指南",
      "博客写作：大多数博客平台支持 Markdown",
      "笔记记录：Notion、Obsidian 等笔记软件首选格式",
      "电子书制作：GitBook、mdBook 等工具",
      "论坛发帖：Stack Overflow、V2EX 等技术社区"
    ],
    "markdownTips": "Markdown 写作技巧",
    "markdownTipsItems": [
      "合理使用标题层级，让文档结构清晰",
      "代码块记得标注语言类型，便于语法高亮",
      "善用列表组织并列信息，提高可读性",
      "图片建议使用图床或相对路径管理",
      "复杂表格可以使用在线表格生成器"
    ]
  },
  "image": {
    "title": "图片处理",
    "subtitle": "在浏览器本地缩放图片、应用滤镜并导出 JPEG，不支持裁剪或透明输出",
    "uploadHint": "点击或拖拽上传图片",
    "supportedFormats": "支持 JPG、PNG、GIF、WebP 格式",
    "basicAdjust": "基本调整",
    "quality": "质量压缩",
    "scale": "缩放比例",
    "filterEffects": "滤镜效果",
    "imageInfo": "图片信息",
    "originalSize": "原始尺寸",
    "outputSize": "输出尺寸",
    "originalFileSize": "原始大小",
    "estimatedSize": "输出文件大小（实际编码）",
    "download": "下载图片",
    "reset": "重置",
    "clear": "清除",
    "filters": {
      "none": "原图",
      "grayscale": "黑白",
      "sepia": "复古",
      "invert": "反色",
      "blur": "模糊",
      "brightness": "增亮",
      "contrast": "高对比",
      "saturate": "饱和"
    },
    "whyCompress": "为什么需要压缩图片？",
    "whyCompressDesc": "在互联网时代，图片是网页和应用中最重要的内容形式之一。然而，高清图片往往体积较大，会影响网页加载速度、消耗用户流量、占用存储空间。合理压缩图片可以在保持视觉质量的同时，大幅减小文件体积，提升用户体验。",
    "formatGuide": "常见图片格式详解",
    "formatGuideItems": [
      "JPEG/JPG：适合照片和复杂图像，支持有损压缩，不支持透明背景",
      "PNG：支持透明背景和无损压缩，适合图标、Logo、截图",
      "GIF：支持动画和透明，但颜色限制在 256 色，适合简单动图",
      "WebP：Google 开发的现代格式，同质量下体积比 JPEG 小 25-34%",
      "SVG：矢量格式，无限缩放不失真，适合图标和简单图形"
    ],
    "compressionTips": "图片压缩技巧",
    "compressionTipsItems": [
      "照片类图片使用 JPEG 格式，质量 70-85% 通常足够",
      "需要透明背景的图片使用 PNG 或 WebP",
      "尺寸压缩比质量压缩效果更明显，根据实际显示尺寸调整",
      "批量上传到网站前，建议统一处理图片尺寸和格式",
      "移动端显示的图片可以使用更低的分辨率"
    ],
    "privacyNote": "隐私保护说明",
    "privacyNoteDesc": "本工具的所有图片处理都在您的浏览器本地完成，您上传的图片不会被发送到任何服务器。处理完成后，图片数据仅存在于您的设备中，关闭页面后即被清除。您可以放心处理包含敏感信息的图片。",
    "webOptimization": "网页图片优化建议",
    "webOptimizationItems": [
      "首屏图片优先加载，非首屏图片使用懒加载",
      "根据设备像素比提供不同分辨率的图片（响应式图片）",
      "使用 CDN 加速图片访问，启用缓存策略",
      "考虑使用 WebP 格式，并为不支持的浏览器提供 JPEG 回退",
      "压缩后图片建议控制在 200KB 以内"
    ]
  },
  "textDedup": {
    "title": "文本去重工具",
    "subtitle": "快速去除文本中的重复内容，支持按行、按逗号、按句子等多种分隔方式",
    "dedup": "开始去重",
    "inputLabel": "输入文本",
    "outputLabel": "去重结果",
    "inputPlaceholder": "请输入或粘贴需要去重的文本...",
    "outputPlaceholder": "去重后的结果将显示在这里...",
    "trimLines": "去除首尾空格",
    "ignoreCase": "忽略大小写",
    "ignoreEmpty": "忽略空项",
    "splitMode": "分割方式：",
    "splitByLine": "按行分割",
    "splitByComma": "按逗号分割",
    "splitBySentence": "按句子分割",
    "splitByCustom": "自定义分隔符",
    "customSepPlaceholder": "输入分隔符",
    "success": "去重完成！",
    "statsInfo": "共 {total} 项，去除 {removed} 个重复项，剩余 {remain} 项",
    "whatIs": "什么是文本去重？",
    "whatIsDesc": "文本去重是指从一段文本中移除重复出现的行或内容。在日常工作中，我们经常会遇到从数据库导出的数据、日志文件、邮件列表等包含大量重复项的情况。手动删除这些重复数据既耗时又容易遗漏，使用文本去重工具可以一键完成清理，大幅提高工作效率。本工具完全在浏览器本地运行，您的数据不会被上传到任何服务器，安全可靠。",
    "useCasesTitle": "文本去重的应用场景",
    "useCases": [
      "数据清洗：清理从数据库、Excel 导出的重复记录",
      "邮件列表整理：去除重复的邮箱地址或联系人信息",
      "日志分析：过滤重复的日志条目，快速定位问题",
      "关键词整理：SEO 关键词列表去重，避免重复投放",
      "代码开发：清理重复的配置项、URL 列表或 IP 地址"
    ],
    "featuresTitle": "工具功能特点",
    "features": [
      "支持按行去重，精确匹配每一行内容",
      "可选忽略大小写，灵活处理英文文本",
      "自动过滤空行，保持结果整洁",
      "实时统计去重数量，一目了然",
      "所有处理在浏览器本地完成，保护数据隐私"
    ],
    "tipsTitle": "使用技巧",
    "tips": [
      "处理大量数据时，建议先勾选\"忽略空行\"以减少干扰",
      "英文数据去重时，可以勾选\"忽略大小写\"避免因大小写不同而保留重复项",
      "去重后可以配合\"文本排序\"工具对结果进行排序整理",
      "如果需要保留原始顺序，本工具默认保留每个重复项的首次出现"
    ]
  },
  "textReplace": {
    "title": "文本替换工具",
    "subtitle": "在线文本查找与替换，支持正则表达式",
    "findLabel": "查找内容",
    "replaceLabel": "替换为",
    "findPlaceholder": "输入要查找的文本...",
    "replacePlaceholder": "输入替换后的文本（留空则删除匹配内容）",
    "replace": "执行替换",
    "ignoreCase": "忽略大小写",
    "useRegex": "使用正则表达式",
    "replaceAll": "全部替换",
    "inputLabel": "输入文本",
    "outputLabel": "替换结果",
    "inputPlaceholder": "请输入或粘贴需要处理的文本...",
    "outputPlaceholder": "替换后的结果将显示在这里...",
    "emptyFind": "请输入要查找的内容",
    "success": "替换完成！",
    "regexError": "正则表达式错误",
    "countInfo": "共替换 {n} 处",
    "whatIs": "什么是文本替换？",
    "whatIsDesc": "文本替换是文本编辑中最基础也最常用的功能之一。无论是修改文档中的特定词汇、批量更新代码中的变量名，还是清理文本中的特定字符，文本替换工具都能帮你快速完成。本工具不仅支持简单的文本查找替换，还支持强大的正则表达式匹配，可以实现复杂的文本处理需求。所有操作在浏览器本地完成，保护您的数据安全。",
    "useCasesTitle": "文本替换的应用场景",
    "useCases": [
      "批量修改文档内容：替换过时的产品名称、联系方式等信息",
      "代码重构：批量替换变量名、函数名或 API 地址",
      "数据格式转换：将逗号分隔符替换为制表符，或反向操作",
      "清理特殊字符：去除多余的空格、换行符或不可见字符",
      "内容审核：将敏感词替换为星号或其他替代文本"
    ],
    "regexTitle": "正则表达式入门",
    "regexDesc": "正则表达式是一种强大的文本匹配模式，可以实现复杂的查找替换操作。以下是一些常用的正则表达式示例：",
    "regexExamples": [
      "\\d+ 匹配一个或多个数字，如匹配 \"abc123\" 中的 \"123\"",
      "\\s+ 匹配一个或多个空白字符，可用于将多个空格替换为单个空格",
      "^\\s+ 匹配行首的空格，可用于去除缩进",
      "\\s+$ 匹配行尾的空格，可用于去除尾随空格",
      "<[^>]+> 匹配HTML标签，可用于去除HTML代码中的标签",
      "(\\d{4})-(\\d{2})-(\\d{2}) 匹配日期格式，可以用 $3/$2/$1 重新排列"
    ]
  },
  "textSort": {
    "title": "文本排序工具",
    "subtitle": "对文本按行排序、反转或随机打乱顺序",
    "sortAsc": "升序排列",
    "sortDesc": "降序排列",
    "reverse": "反转顺序",
    "shuffle": "随机打乱",
    "ignoreCase": "忽略大小写",
    "numericSort": "按数字排序",
    "removeEmpty": "移除空行",
    "inputLabel": "输入文本",
    "outputLabel": "排序结果",
    "inputPlaceholder": "请输入或粘贴需要排序的文本，每行一条数据...",
    "outputPlaceholder": "排序后的结果将显示在这里...",
    "success": "排序完成！",
    "whatIs": "什么是文本排序？",
    "whatIsDesc": "文本排序工具可以对文本内容按行进行排序处理。支持按字母升序（A-Z）、降序（Z-A）排列，也支持反转行顺序和随机打乱。对于中文文本，会按照拼音顺序排列；对于包含数字的文本，可以启用数字排序模式。该工具在数据整理、列表排序、代码格式化等场景中非常实用，所有处理都在浏览器本地完成。",
    "useCasesTitle": "文本排序的应用场景",
    "useCases": [
      "字母表排序：将名单、词汇表按字母或拼音顺序排列",
      "数据整理：将数值数据从小到大或从大到小排列",
      "代码格式化：将 import 语句、CSS 属性按字母排序",
      "反转文本：将最后一行移到第一行，用于逆序查看日志",
      "随机排列：打乱选项顺序，适用于抽签、随机排序等场景",
      "去重排序：配合去重工具，先去重再排序，生成整洁的列表"
    ],
    "featuresTitle": "工具功能特点",
    "features": [
      "支持升序、降序、反转和随机四种排序方式",
      "中文按拼音排序，英文按字母排序",
      "数字排序模式：将 \"2\" 排在 \"10\" 前面（而非字符串排序的 \"10\" 在 \"2\" 前）",
      "可选忽略大小写，让 \"apple\" 和 \"Apple\" 排在一起",
      "自动过滤空行，保持结果整洁"
    ]
  },
  "textNumber": {
    "title": "文本添加序号",
    "subtitle": "为文本每行自动添加编号，支持多种格式",
    "startNum": "起始序号",
    "separator": "分隔符",
    "position": "序号位置",
    "before": "行首",
    "after": "行尾",
    "tab": "制表符",
    "skipEmpty": "跳过空行",
    "padZero": "序号补零",
    "addNumber": "添加序号",
    "removeNumber": "移除序号",
    "inputLabel": "输入文本",
    "outputLabel": "处理结果",
    "inputPlaceholder": "请输入或粘贴需要添加序号的文本，每行一条...",
    "outputPlaceholder": "添加序号后的结果将显示在这里...",
    "success": "序号添加完成！",
    "removeSuccess": "序号移除完成！",
    "whatIs": "什么是文本添加序号？",
    "whatIsDesc": "文本添加序号工具可以为文本的每一行自动添加编号。无论是整理学习笔记、制作编号列表、还是处理数据文件，都可以快速完成。支持多种序号格式（如 \"1.\" \"1)\" \"1、\" 等），可以自定义起始数字，还能选择将序号添加在行首或行尾。同时也支持一键移除已有序号，方便反复编辑。",
    "useCasesTitle": "应用场景",
    "useCases": [
      "整理笔记：为学习笔记或会议纪要添加编号",
      "制作清单：快速为待办事项、购物清单等添加序号",
      "文档编辑：为合同条款、规章制度添加条目编号",
      "数据处理：为 CSV 数据行添加行号便于后续引用",
      "代码注释：为代码行添加行号方便讨论和审查"
    ]
  },
  "namingConverter": {
    "title": "命名转换器",
    "subtitle": "在不同编程命名规范之间快速转换，支持驼峰、下划线、短横线等多种格式",
    "inputLabel": "输入标识符名称",
    "inputPlaceholder": "输入任意格式的变量名，如 myVariableName、my_variable_name、my-variable-name...",
    "whatIs": "什么是命名转换器？",
    "whatIsDesc": "在编程中，不同的语言和场景使用不同的命名规范。命名转换器可以帮助你在各种命名格式之间快速切换，避免手动修改的繁琐和错误。只需输入一种格式的名称，即可自动生成所有其他格式的变体。所有转换在浏览器本地完成，安全可靠。",
    "stylesTitle": "常见命名格式说明",
    "styles": [
      "camelCase（小驼峰）：JavaScript 变量和函数名的标准，如 getUserName",
      "PascalCase（大驼峰）：类名和组件名常用，如 UserProfile",
      "snake_case（下划线）：Python、Ruby 和数据库字段的标准，如 user_name",
      "kebab-case（短横线）：HTML 属性、CSS 类名和 URL 的标准，如 user-profile",
      "CONSTANT_CASE（常量）：全大写+下划线，用于常量定义，如 MAX_RETRY_COUNT",
      "dot.case（点号分隔）：用于配置文件和包名，如 com.example.app",
      "path/case（路径分隔）：用于文件路径，如 user/profile/avatar",
      "Title Case（标题格式）：每个单词首字母大写，如 User Profile Name",
      "Sentence case（句子格式）：仅首字母大写，如 User profile name"
    ],
    "tipsTitle": "使用技巧",
    "tips": [
      "输入时支持自动识别 camelCase、PascalCase、snake_case、kebab-case 等格式",
      "也支持输入空格分隔的普通文本，会自动拆分为单词",
      "点击每种格式右侧的复制按钮可快速复制结果"
    ]
  },
  "colorConverter": {
    "title": "颜色值转换工具",
    "subtitle": "在 HEX、RGB、HSL 等颜色格式之间互相转换，带实时预览",
    "pickerLabel": "使用取色器：",
    "whatIs": "什么是颜色值转换？",
    "whatIsDesc": "在前端开发和设计中，颜色可以用多种格式表示：HEX（十六进制）、RGB（红绿蓝）、HSL（色相饱和度亮度）等。不同的场景和工具可能需要不同的颜色格式。颜色值转换工具可以帮助你在各种格式之间快速转换，并提供实时颜色预览。所有处理在浏览器本地完成。",
    "formatsTitle": "颜色格式详解",
    "formats": [
      "HEX（十六进制）：如 #FF5733，是CSS中最常用的颜色格式，由 # 加6位十六进制数组成",
      "RGB（红绿蓝）：如 rgb(255, 87, 51)，用0-255表示红、绿、蓝三个颜色通道的值",
      "RGBA：在 RGB 基础上增加透明度通道（Alpha），如 rgba(255, 87, 51, 0.8)",
      "HSL（色相饱和度亮度）：如 hsl(9, 100%, 60%)，更符合人类对颜色的直觉理解",
      "HSLA：在 HSL 基础上增加透明度通道"
    ],
    "tipsTitle": "使用技巧",
    "tips": [
      "可以直接编辑任何一种格式的输入框，其他格式会自动同步更新",
      "使用取色器可以直接从调色板选择颜色",
      "点击每种格式右侧的复制按钮可快速复制 CSS 颜色值",
      "HEX 格式支持 3 位简写（如 #F00）自动展开为 6 位"
    ]
  },
  "listSum": {
    "title": "列表求和计算器",
    "subtitle": "对一组数字快速求和，同时提供平均值、最大值、最小值等统计信息",
    "inputLabel": "输入数字列表",
    "inputPlaceholder": "每行输入一个数字，例如：\n100\n200.5\n300\n-50\n150.75",
    "separatorLabel": "分隔方式：",
    "sepLine": "按行",
    "sepComma": "按逗号",
    "sepSpace": "按空格",
    "sepTab": "按 Tab",
    "ignoreNonNumber": "忽略非数字项",
    "decimalMode": "高精度小数",
    "sum": "求和结果",
    "average": "平均值",
    "count": "数字个数",
    "max": "最大值",
    "min": "最小值",
    "median": "中位数",
    "parsedList": "识别到的数字",
    "skippedInfo": "已跳过 {n} 个非数字项",
    "whatIs": "什么是列表求和？",
    "whatIsDesc": "列表求和计算器可以对一组数字快速进行求和运算，同时自动计算平均值、最大值、最小值和中位数等常用统计指标。支持多种分隔方式（换行、逗号、空格、Tab），可以直接粘贴从表格或文档中复制的数据。所有计算在浏览器本地完成。",
    "tipsTitle": "使用技巧",
    "tips": [
      "可以直接从 Excel、WPS 等表格软件中复制一列数据粘贴到输入框",
      "支持负数和小数，如 -100 和 3.14",
      "支持千分位格式的数字，如 1,234,567.89 会自动识别",
      "如果数据中混有文字，勾选\"忽略非数字项\"可以自动过滤",
      "切换不同的分隔方式来适配不同格式的数据"
    ]
  },
  "base64": {
    "title": "Base64 编解码",
    "subtitle": "在线 Base64 编码与解码工具，支持中文和特殊字符处理",
    "inputLabel": "输入文本",
    "outputLabel": "输出结果",
    "inputPlaceholder": "请输入需要编码或解码的文本...",
    "outputPlaceholder": "结果将显示在这里...",
    "encode": "编码",
    "decode": "解码",
    "swap": "交换输入输出",
    "encodeSuccess": "Base64 编码成功！",
    "encodeError": "编码失败，请检查输入内容",
    "decodeSuccess": "Base64 解码成功！",
    "decodeError": "解码失败，请确认输入的是有效的 Base64 字符串",
    "whatIs": "什么是 Base64？",
    "whatIsDesc": "Base64 是一种基于 64 个可打印字符来表示二进制数据的编码方式。它常用于在需要以文本形式处理二进制数据的场景中，如电子邮件附件编码、在 URL 中嵌入数据、在 CSS 中内嵌小图片（Data URI）等。Base64 编码后的数据体积约增大 33%，但确保数据在传输过程中不会被错误处理。所有编解码操作均在浏览器本地完成，保护您的数据安全。",
    "useCasesTitle": "常见应用场景",
    "useCases": [
      "邮件附件编码：MIME 协议使用 Base64 对邮件附件进行编码",
      "Data URI：在 HTML/CSS 中直接嵌入小图片或字体文件",
      "API 传输：在 JSON 或 URL 中安全传递二进制数据",
      "JWT Token：JSON Web Token 使用 Base64 编码其头部和载荷部分",
      "数据存储：将二进制数据以文本形式存储在数据库或配置文件中"
    ],
    "tipsTitle": "使用技巧",
    "tips": [
      "本工具支持中文编码，内部使用 UTF-8 编码处理",
      "Base64 不是加密，不能用于保护敏感数据",
      "编码后的字符串只包含 A-Z、a-z、0-9、+、/ 和 = 字符",
      "如果解码失败，请检查输入是否为合法的 Base64 字符串"
    ]
  },
  "urlCodec": {
    "title": "URL 编解码",
    "subtitle": "在线 URL 编码与解码工具，支持 encodeURI 和 encodeURIComponent",
    "inputLabel": "输入文本",
    "outputLabel": "输出结果",
    "inputPlaceholder": "请输入需要编码或解码的 URL 或文本...",
    "outputPlaceholder": "结果将显示在这里...",
    "encode": "encodeURI",
    "decode": "解码",
    "encodeComponent": "encodeURIComponent",
    "swap": "交换输入输出",
    "encodeSuccess": "编码成功！",
    "decodeSuccess": "解码成功！",
    "decodeError": "解码失败，请检查输入内容",
    "error": "编码出错",
    "whatIs": "什么是 URL 编码？",
    "whatIsDesc": "URL 编码（也叫百分号编码）是一种将特殊字符转换为 %XX 形式的编码方式，使其可以安全地在 URL 中传输。URL 规范只允许使用 ASCII 字符集中的一部分字符，中文、空格、特殊符号等字符必须经过编码后才能出现在 URL 中。JavaScript 提供了 encodeURI 和 encodeURIComponent 两个函数，它们的编码范围不同。所有操作均在浏览器本地完成。",
    "useCasesTitle": "常见应用场景",
    "useCases": [
      "URL 参数传递：将中文、空格等特殊字符编码后放入 URL 参数中",
      "API 请求：确保 GET 请求中的查询参数格式正确",
      "表单提交：浏览器会自动对表单数据进行 URL 编码",
      "前端路由：对动态路由参数中的特殊字符进行编码",
      "链接分享：确保包含特殊字符的链接可以被正确打开"
    ],
    "tipsTitle": "使用技巧",
    "tips": [
      "encodeURI：编码整个 URL，保留 :/?#[]@!$&'()*+,;= 等 URL 功能字符",
      "encodeURIComponent：编码 URL 中的参数部分，会编码除 -_.!~*'() 外的所有特殊字符",
      "一般传递参数值时使用 encodeURIComponent，编码完整 URL 时使用 encodeURI",
      "如果解码出现乱码，可能是编码格式不匹配，请检查原始编码方式"
    ]
  },
  "hashTool": {
    "title": "MD5/SHA 哈希计算",
    "subtitle": "在线计算文本的 MD5、SHA-1、SHA-256、SHA-384、SHA-512 哈希值",
    "inputLabel": "输入文本",
    "inputPlaceholder": "请输入需要计算哈希值的文本...",
    "outputCase": "输出格式",
    "upper": "大写",
    "lower": "小写",
    "whatIs": "什么是哈希算法？",
    "whatIsDesc": "哈希算法（Hash Algorithm）是一种将任意长度的输入数据转换为固定长度输出（哈希值/摘要）的算法。好的哈希算法具有单向性（无法从哈希值反推原始数据）、确定性（相同输入总是产生相同输出）和抗碰撞性（很难找到两个不同输入产生相同输出）。哈希算法广泛用于数据完整性校验、密码存储、数字签名等场景。本工具所有计算均在浏览器本地完成。",
    "algosTitle": "支持的哈希算法",
    "algos": [
      "MD5：128 位输出，计算速度快，但已不推荐用于安全场景，适合文件校验",
      "SHA-1：160 位输出，已被证明不够安全，正逐步被淘汰",
      "SHA-256：256 位输出，目前最常用的安全哈希算法，比特币使用的核心算法",
      "SHA-384：384 位输出，SHA-256 的加长版，安全性更高",
      "SHA-512：512 位输出，安全性最高，适合对安全要求极高的场景"
    ],
    "useCasesTitle": "常见应用场景",
    "useCases": [
      "文件完整性校验：对比下载文件的哈希值与官方提供的值，验证文件未被篡改",
      "密码存储：将用户密码的哈希值存入数据库，而非明文密码",
      "数据去重：通过比较哈希值快速判断两段数据是否相同",
      "数字签名：对文档或代码生成哈希值，结合非对称加密实现数字签名",
      "区块链：比特币等区块链技术的核心基础之一"
    ]
  },
  "unicodeConverter": {
    "title": "Unicode 编码转换",
    "subtitle": "在 Unicode、十六进制、HTML 实体和 UTF-8 之间互相转换",
    "inputLabel": "输入文本",
    "outputLabel": "转换结果",
    "inputPlaceholder": "请输入需要转换的文本或编码...",
    "outputPlaceholder": "转换结果将显示在这里...",
    "convert": "转换 →",
    "reverse": "反向转换",
    "mode": {
      "unicode": "Unicode (\\uXXXX)",
      "hex": "十六进制 (\\xXX)",
      "htmlEntity": "HTML 实体 (&#NNN;)",
      "utf8Hex": "UTF-8 十六进制"
    },
    "whatIs": "什么是 Unicode？",
    "whatIsDesc": "Unicode 是一种国际字符编码标准，旨在为世界上所有的文字和符号提供统一的编码。Unicode 定义了超过 14 万个字符，覆盖了几乎所有的人类语言。在编程中，经常需要在不同编码格式之间转换，例如将中文转换为 \\uXXXX 格式在 JSON 中传输，或将特殊字符转为 HTML 实体在网页中显示。本工具支持多种编码格式的互转，所有操作在浏览器本地完成。",
    "useCasesTitle": "常见应用场景",
    "useCases": [
      "JSON 编码：在 JSON 中使用 \\uXXXX 格式表示中文和特殊字符",
      "HTML 编码：使用 HTML 实体避免特殊字符被浏览器错误解析",
      "JavaScript 转义：在 JS 代码中使用 \\xXX 或 \\uXXXX 表示特殊字符",
      "国际化开发：处理多语言文本的编码转换需求",
      "数据调试：查看字符的底层编码表示，排查编码问题"
    ]
  },
  "passwordGen": {
    "title": "随机密码生成器",
    "subtitle": "生成安全的随机密码，支持自定义规则和批量生成",
    "placeholder": "点击生成按钮创建密码",
    "length": "密码长度",
    "uppercase": "大写字母",
    "lowercase": "小写字母",
    "numbers": "数字",
    "symbols": "特殊符号",
    "excludeAmbiguous": "排除易混淆字符 (0Oo1Il)",
    "generate": "生成密码",
    "strengthLabel": "密码强度",
    "weak": "弱",
    "medium": "中",
    "strong": "强",
    "batchTitle": "批量生成",
    "batchCount": "生成数量",
    "batchGenerate": "批量生成",
    "whatIs": "为什么需要强密码？",
    "whatIsDesc": "弱密码是网络安全最大的威胁之一。常见密码如 \"123456\"、\"password\" 等可以在几秒内被暴力破解。安全的密码应该足够长（至少 12 位）、包含多种字符类型（大小写字母、数字、符号），并且每个账号使用不同的密码。本工具使用浏览器原生的加密安全随机数生成器（crypto.getRandomValues），确保生成的密码具有真正的随机性。所有密码生成均在浏览器本地完成，不会被发送到任何服务器。",
    "tipsTitle": "密码安全建议",
    "tips": [
      "密码长度至少 12 位，16 位以上更安全",
      "混合使用大写字母、小写字母、数字和特殊符号",
      "每个重要账号使用不同的密码",
      "使用密码管理器（如 1Password、Bitwarden）存储密码",
      "启用双因素认证（2FA）为账号增加额外保护",
      "避免使用个人信息（生日、名字等）作为密码的一部分"
    ]
  },
  "uuidGen": {
    "title": "UUID/GUID 生成器",
    "subtitle": "使用浏览器随机源生成 UUID v4，支持格式设置与批量生成",
    "version": "UUID 版本",
    "caseLabel": "大小写",
    "lower": "小写",
    "upper": "大写",
    "withBraces": "添加花括号 {}",
    "noDashes": "去除横杠 -",
    "batchTitle": "批量生成",
    "batchCount": "生成数量",
    "batchGenerate": "批量生成",
    "whatIs": "什么是 UUID？",
    "whatIsDesc": "UUID（Universally Unique Identifier，通用唯一识别码）是一种 128 位的标识符，设计上可以保证在全球范围内的唯一性。UUID 的格式为 xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx（32 个十六进制字符用 4 个连字符分隔）。UUID 最常用的版本是 v4（基于随机数）和 v1（基于时间戳和 MAC 地址）。UUID 广泛用于数据库主键、分布式系统、会话标识等需要唯一标识符的场景。",
    "useCasesTitle": "常见应用场景",
    "useCases": [
      "数据库主键：避免自增 ID 带来的安全隐患和分布式冲突",
      "分布式系统：在多个服务节点间生成不冲突的唯一标识",
      "会话管理：生成用户会话 ID，确保每个会话唯一",
      "API 请求追踪：为每个请求生成唯一 ID，便于日志追踪",
      "文件命名：上传文件时使用 UUID 命名，避免文件名冲突"
    ],
    "tipsTitle": "使用技巧",
    "tips": [
      "UUID v4 基于随机数，适合大多数场景，简单安全",
      "UUID v1 包含时间信息，可以按时间排序，适合需要时序的场景",
      "数据库中存储 UUID 可以去除横杠以节省空间",
      "UUID 的碰撞概率极低（约 2^122 分之一），实际使用中可以认为不会重复",
      "如需更短的唯一 ID，可以考虑使用 NanoID 等替代方案"
    ]
  }
}
